module.exports = __webpack_public_path__ + "img/42_47.59d1fe15.png";